var map = {
  "./cs.json": [
    "dW",
    [
      "n1"
    ]
  ],
  "./en.json": [
    "FNM",
    [
      "zi"
    ]
  ],
  "./pl.json": [
    "NSL",
    [
      "ny"
    ]
  ],
  "./ru.json": [
    "lFU",
    [
      "fqf"
    ]
  ],
  "./tr.json": [
    "cx2",
    [
      "u4"
    ]
  ],
  "./ja.json": [
    "NHD",
    [
      "fl"
    ]
  ],
  "./zh.json": [
    "ix6",
    [
      "k8"
    ]
  ],
  "./pt-br.json": [
    "Ao",
    [
      "u7"
    ]
  ],
  "./de.json": [
    "byM",
    [
      "9m"
    ]
  ],
  "./es.json": [
    "J02",
    [
      "ry"
    ]
  ],
  "./fr.json": [
    "Vaj",
    [
      "3ln"
    ]
  ],
  "./it.json": [
    "y8N",
    [
      "wki"
    ]
  ],
  "./ko.json": [
    "pn",
    [
      "7z"
    ]
  ],
  "./pt.json": [
    "SX",
    [
      "k1"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "bN";
module.exports = __rspack_async_context;
